import { ReactNode } from "react";
import { Alert, AlertDescription } from "@zapier/design-system";
import { ProgressBar } from "../ProgressBar";
import styles from "./BannerWrapper.module.css";

type Props = {
  title: string;
  description: string;
  children?: ReactNode;
  showProgress?: boolean;
};

/** IMPORTANT! This banner wrapper is s being used in the following locations:
 *  - AI Copilot
 *  - template page (ex: app/canvas/template/lead-capture)
 *  - template page logged out view
 *  _ upgrade banner
 *
 *  Be conscientious that changes made here will affect all of them.
 *
 * */
export function BannerWrapper({
  title,
  description,
  children,
  showProgress = false,
}: Props) {
  return (
    <div className={styles.wrapper}>
      <Alert status="info" title={title} variant="banner">
        <div className={styles.descriptionWrapper}>
          <AlertDescription>{description}</AlertDescription>
        </div>
        <div className={styles.buttonsWrapper}>{children}</div>
      </Alert>
      {showProgress && (
        <div className={styles.progressBarWrapper}>
          <ProgressBar />
        </div>
      )}
    </div>
  );
}
